export class ObjectData {

    static from(model: { id: number, name: string }): ObjectData {
        return new ObjectData(model.id, model.name);
    }

    static empty(name: string = ''): ObjectData {
        return new ObjectData(0, name);
    }

    constructor(readonly id: number, readonly value: string) {
    }
}



// WEBPACK FOOTER //
// ./src/api/request/ObjectData.ts